import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=bda88196"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports